// extracted by mini-css-extract-plugin
export default {"btn-wrapper":"header_btn-wrapper__xntpi","btn":"header_btn__aFtxg","white":"header_white__6CoL6","black":"header_black__2M2hE"};